import collection from './user/collection';
import item from './user/item';

const user = {
  namespaced: true,
  modules: {
    collection,
    item,
  },
};

export default user;
